import React from 'react';
import { Link } from 'react-router-dom';
import img from '../../assets/images/img.png';
import img1 from '../../assets/images/img1.png';
import { 
  Container, 
  Item, 
  CaptionWrap, 
  WrapCaption 
} from './styles';

const About = () => (
  <Container>
      <WrapCaption>
          <h1>About me</h1>
          <img src={img} alt="" /> 
      </WrapCaption>
      <CaptionWrap>
        <Item>
          <img src={img1} alt="" /> 
          <span>I'm 20 years old, I'm from Natal-RN, Brazil. I am currently a student of Analysis and Development  of Systems at UFRN.</span>
        </Item>
      </CaptionWrap>
    <Link to="/about">SEE MORE</Link>
  </Container>
);
export default About;